import { useEffect, useState } from "react";
import { BasicButton } from "../../../../../theme/Component/BasicButton";
import { _ItemFlow, _single } from "../../../../../../core/services/dataBean/EntityCatalog";
import { ContractService } from "../../../../../../core/services/ContractService";
import useDataBean from "../../../../../../core/services/dataBean/useDataBean";
import { toast } from "react-toastify";

interface Props {
    exportMap: Function;
    procedure: any;
}

export const EP06 = ({ exportMap, procedure }: Props) => {

    const { instance, setBean, bean } = useDataBean(_ItemFlow);
    const [obs, setObs] = useState<string>("")
    const service = new ContractService();
    const [invalid, setInvalid] = useState<boolean>(false)

    const onExportMap = (approve: boolean) => {
        exportMap({
            Approve: approve == true ? "true" : "false",
            Decline: approve == false ? "true" : "false",
            Observation: obs
        })
    }

    useEffect(() => {
        getItem();
    }, [procedure])

    const getItem = () => {
        let x = {
            IDProcedureImp: procedure.IDProcedureImp,
        };
        instance.getItemFlowCatalogPorPropiedades(x, null).then(
            (resp) => {
                if (resp.length > 0) {
                    setBean(resp[0])
                }
            }
        ).catch(err => { console.log(err) })
    }

    const updateState = (_approve: boolean) => {
        if (!obs || obs.length < 15) {
            toast.error("La observación es obligatoria y debe tener al menos 15 caracteres.")
            setInvalid(true);
        } else {
            if (_approve == false) {
                _single.spinner(true);
                service.changeAdquisitionItemApprovalNote(bean.DataBeanProperties?.IDAdquisitionItem, _single.getAccountID(), obs, 8).subscribe(
                    (resp: any) => {
                        onExportMap(_approve);
                        _single.spinner(false)
                    }
                )
            } else {
                _single.spinner(true);
                service.changeAdquisitionItemApprovalNote(bean.DataBeanProperties?.IDAdquisitionItem, _single.getAccountID(), obs, 6).subscribe(
                    (resp: any) => {
                        onExportMap(_approve);
                        _single.spinner(false)
                    }
                )
            }
        }
    }

    return (
        <div className="row d-flex justify-content-between">
            <p>¿Desea Volver a presenar el proceso de Estudio Previo?</p>
            <div className="col-md-12 mb-2">
                <label>Observaciones</label>
                <textarea className={`form-control ${invalid ? "is-invalid" : ""}`} value={obs} onChange={(e) => { setObs(e.target.value) }} />
            </div>
            <div className="col-md-4">
                <BasicButton icon="ri-checkbox-circle-line" eventClick={() => { updateState(true) }} >Continuar</BasicButton>
            </div>
            <div className="col-md-4">
                <BasicButton icon="ri-close-circle-line" eventClick={() => { updateState(false) }} >Declinar</BasicButton>
            </div>
        </div>
    );
};